import { uniq } from 'lodash'
import { Button, Checkbox } from '@offerzen/pinata'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import styles from './style'

const LocationFilter = ({ onApply, locations, filterValues, open, closeFilter }) => {
  const [selectedLocations, setSelectedLocations] = useState(filterValues || [])

  React.useEffect(() => {
    if (filterValues) {
      setSelectedLocations(filterValues.map(filter => locations.find(item => item.name === filter.name)))
    }
  }, [filterValues])

  // Fix for remote location. There is no associated country, so for the selector, we set it to other
  if (locations && locations.length) {
    locations.find(location => location.country === 'Remote' || !location.country).country = 'Remote'
  }

  const isRegionSelected = React.useCallback(
    region => selectedLocations?.filter(location => location.country === region).length > 0,
    [selectedLocations],
  )

  const renderCitiesList = useCallback(() => {
    const regions = uniq(locations.map(location => location.country)).filter(location => location !== null)
    const regionUI = []

    for (const key in regions) {
      const region = regions[key]
      const locationsByRegion = locations.filter(location => location.country === region)
      const sortedLocationsByRegion = locationsByRegion.sort((a, b) => a.name.localeCompare(b.name))
      const regionSelected = isRegionSelected(region)

      const citiesUI = (
        <div>
          <Checkbox
            label={region}
            id={region?.replaceAll(' ', '-')}
            key={key}
            checked={regionSelected}
            className={styles.checkbox}
            onChange={() => {
              if (regionSelected) {
                const filteredRegions = selectedLocations.filter(location => location.country !== region)
                setSelectedLocations(filteredRegions)
                onApply(
                  filteredRegions.map(location => ({
                    name: location.name,
                    value: location.name,
                  })),
                )
              } else {
                const filteredRegions = [...selectedLocations.filter(location => location.country !== region), ...locationsByRegion]
                setSelectedLocations(filteredRegions)
                onApply(
                  filteredRegions.map(location => ({
                    name: location.name,
                    value: location.name,
                  })),
                )
              }
            }}
          />
          {selectedLocations &&
            sortedLocationsByRegion.map((city, index) => {
              const citySelected = selectedLocations.find(location => location.name === city.name) !== undefined

              if (city.name !== 'Remote') {
                return (
                  <div key={index}>
                    <Checkbox
                      label={city.name}
                      id={city.name.replaceAll(' ', '-')}
                      checked={citySelected}
                      className={styles.cityCheckbox}
                      onChange={() => {
                        if (!citySelected) {
                          setSelectedLocations([...selectedLocations, city])
                          onApply(
                            [city, ...selectedLocations].map(location => ({
                              name: location.name,
                              value: location.name,
                            })),
                          )
                        } else {
                          const filteredLocations = selectedLocations.filter(location => location.name !== city.name)
                          setSelectedLocations(filteredLocations)
                          onApply(
                            filteredLocations.map(location => ({
                              name: location.name,
                              value: location.name,
                            })),
                          )
                        }
                      }}
                    />
                  </div>
                )
              }
            })}
        </div>
      )
      regionUI.push(citiesUI)
    }
    return regionUI
  }, [selectedLocations, locations])

  return (
    <section role="location-filter" className={styles.wrapper}>
      {renderCitiesList()}
      <div className={styles.buttonWrapper}>
        <div className={styles.action}>
          <Button label="Apply" size="medium" theme="primary" onClick={closeFilter} />
        </div>
      </div>
    </section>
  )
}

LocationFilter.propTypes = {
  locations: PropTypes.array,
  onApply: PropTypes.func,
  filterValues: PropTypes.array,
  closeFilter: PropTypes.func,
  open: PropTypes.string,
}

export default LocationFilter
